module.exports = __webpack_public_path__ + "img/career-history.891c21a9.svg";